import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Support from '../views/Support.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/support',
    name: 'Support',
    component: Support,
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: ':project'
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
